var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "82px",
    viewBox: "0 0 82 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "round_laptop_light") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-2021",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "round_laptop_light",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#000000",
    strokeWidth: 2,
    cx: 40,
    cy: 40,
    r: 40
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "Device/Computer"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.912338, 24.825000)",
    id: "Group",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Device/Computer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.92819844,23.912262 L35.1305483,23.912262 L35.1305483,6.40347498 L9.92819844,6.40347498 L9.92819844,23.912262 Z M37.1279374,23.912262 L39.3015666,23.912262 L39.3015666,4.33144205 C39.3015666,2.74528016 38.7140993,2.07203294 37.1866842,2.07203294 L7.81331592,2.07203294 C6.28590078,2.07203294 5.69843344,2.74528016 5.69843344,4.33144205 L5.69843344,23.912262 L7.87206267,23.912262 L7.87206267,4.33144205 L37.1279374,4.33144205 L37.1279374,23.912262 Z M40.2415144,28.3047103 C41.4164491,28.3047103 42.0039165,27.8798454 42.4151438,26.7185484 L42.7088774,25.9276462 L2.29112273,25.9276462 L2.5848564,26.7185484 C2.99608356,27.8798454 3.58355092,28.3047103 4.75848565,28.3047103 L40.2415144,28.3047103 Z M40.2415144,30.3811007 L4.75848565,30.3811007 C2.52610967,30.3811007 1.52741514,29.5248348 0.52872063,26.7185484 L-4.31636434e-16,25.1955714 L1.46866842,23.912262 L3.64229766,23.912262 L3.64229766,4.33144205 C3.64229766,1.40096437 4.9934726,-3.45309147e-15 7.81331592,-3.45309147e-15 L37.1866842,-3.45309147e-15 C40.0065275,-3.45309147e-15 41.3577025,1.40096437 41.3577025,4.33144205 L41.3577025,23.912262 L43.5313317,23.912262 L45,25.1955714 L44.4712795,26.7185484 C43.4725849,29.5248348 42.4738904,30.3811007 40.2415144,30.3811007 Z",
    id: "path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPc);
export default __webpack_public_path__ + "static/media/pc.e89d6d41dd71d4aad5f65ba24eb26d09.svg";
export { ForwardRef as ReactComponent };